import { Component, OnInit } from '@angular/core';
import { StepperNavigationService } from '../../services/stepper-navigation.service';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { VentaService } from '../../services/venta.service';
import { filter } from 'rxjs/operators';
import { Pasos } from '../../models/breadcrumbs';
import { SidebarNavigationService } from 'src/app/shared/services/sidebar-navigation.service';
@Component({
  selector: 'ticketing-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss']
})
export class StepperComponent implements OnInit {
  pasos: Pasos[] = [];

  constructor(
    private stepperNavigation: StepperNavigationService,
    private venta: VentaService,
    public route: ActivatedRoute,
    private router: Router,
    private sidebarNavigation: SidebarNavigationService 
  ) {}

  ngOnInit() {
    this.stepperNavigation.getSteps().subscribe(pasos => {
      this.pasos = pasos;
    });

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
      )
      .subscribe((event: NavigationEnd) => {
        this.stepperNavigation.getUrlVentaSlice();
      })
  }

  navegar(url) {
    if (this.pasos.findIndex(paso => paso.url === url) === 0) {
      const initialUrl = url === 'entradas' ? '' : url;
      this.stepperNavigation.desbloquearNavegacionPorPago();
      this.stepperNavigation.resetearPasos();
      this.stepperNavigation.continuarVenta.next(false);
      this.venta.currentRecinto = undefined;
      this.sidebarNavigation.unblockSecciones();

      const updatedUrl = url === 'actividades' ? `auditorio/${url}` : initialUrl;
      this.router.navigate([updatedUrl]);
    } else {
      this.stepperNavigation.continuarVenta.next(true);
      this.router.navigate([`venta/${url}`]);
    }
  }
}
